<template>
<div>
  <div class="dashboard">
  <div class="container-fluid">
          <div class="ml-2 mt-3 mb-2">
          Overview Dashboard
          </div>
    <div class="d-flex flex-row p-0 wbg mb-3 bshadow text-dark">

       <div class="card-body">
         <img class="card-img-top" src="../assets/images/Payments.fw.png" alt="Card image"
          style="width:50px"> &nbsp; &nbsp;
          <b>Today Payments</b>
          <div class="ml-5 pl-4">
            <p v-if="todayAmount != '' && todayAmount != null">  ₹ {{todayAmount}}</p>
            <p v-else="todayAmount =='' || todayAmount == null">  ₹ 0</p>
          </div>
       </div>

     <span class="border border-left-0 border-bottom-0 border-top-0"></span>
       <div class="card-body"><img class="card-img-top" src="../assets/images/Payments.fw.png" alt="Card image"
        style="width:50px">&nbsp; &nbsp; Total Payments <div class="ml-5 pl-4">
          ₹ {{totalAmount}}</div></div>
     <span class="border border-left-0 border-bottom-0 border-top-0"></span>
      <div class="card-body"><img class="card-img-top" src="../assets/images/Customers.fw.png" alt="Card image"
        style="width:50px">&nbsp; &nbsp; <b>Vendors Count</b>
        <div class="ml-5 pl-4">
          <p v-if="totalvendors != '' && totalvendors != null">{{totalvendors}}</p>
          <p v-else="totalvendors =='' || totalvendors == null">No Data</p>
        </div>
      </div>
      </div>
    </div>


  </div>

  </div>
</div>
</template>

<script>
export default {
  name: 'Dashboard',

  data() {
        return {
          totalAmount: 0,
          todayAmount: 0,
          totalvendors: 0,
            cordova: ''

        };
    },
    mounted() {
      this.gettotalamount(),
      this.gettodayamount(),
      this.gettotalvendors()

    },
    created () {
      document.addEventListener('deviceready', this.ondeviceready);
    },
  methods: {
    ondeviceready () {
      console.log(device.cordova);
      this.cordova = device.uuid;
      this.$http.post('/auth/endpoint',{
        token: this.cordova
      }).then((res) => {
        console.log(res)
      })
    this.receivedEvent('deviceready');

    var push = PushNotification.init({
        android: {},
        browser: {
            pushServiceURL: 'http://push.api.phonegap.com/v1/push'
        },
        ios: {
            alert: "true",
            badge: "true",
            sound: "true"
        },
        windows: {}
    });
push.on('registration', function (data) {
        console.dir(data)
        alert('Event=registration, registrationId=' + data.registrationId)
    });
push.on('notification', function (data) {
        console.log(data)
        alert('Event=notification, message=' + data.message)
    });
push.on('error', function (err) {
        console.log(err)
        alert('Event=error, message=' + err.message)
    });

    },
    gettotalamount () {
      this.$http.get('/countt/total-revenue').then((res) => {
        if (res.data.success === true) {

          this.totalAmount = res.data.details[0].totalrevenue
        }
      })
    },
    gettodayamount () {
      this.$http.get('/countt/today-revenue').then((res) => {
        if(res.data.success === true) {
          this.todayAmount = res.data.details[0].todayorderamount
        }
      })
    },
    gettotalvendors () {
      this.$http.get('/countt/total-admin').then((res) => {
        if (res.data.success === true) {
          this.totalvendors = res.data.details[0].admincount
        }
      })
    }

  }
}


</script>



// WEBPACK FOOTER //
// src/components/dashboard.vue